import React from 'react'
// @ts-ignore no types
import { Text } from '@adc/ui-adc'

interface WinnerNextStepsProps {
  containerClassName?: string
}

export const WinnerNextSteps = ({
  containerClassName,
}: WinnerNextStepsProps) => {
  return (
    <div className={containerClassName} data-elm-id='winner_next_steps'>
      <Text
        className='u-mb-2'
        color='gray'
        data-elm-id='winner_next_steps_explanation'
      >
        <span>To generate a purchase contract</span>{' '}
        <Text color='success' as='span'>
          complete the Contract Information Form
        </Text>{' '}
        <span>and submit your entity documents (if applicable).</span>
      </Text>
      <Text
        className='u-mb-2'
        color='gray'
        data-elm-id='winner_next_steps_explanation_link'
      >
        To learn more about the process, watch these{' '}
        <a
          href='https://www.auction.com/lp/winning-bidder-resource-center/#video'
          target='_blank'
          rel='noreferrer'
        >
          step-by-step videos
        </a>
      </Text>
    </div>
  )
}

export default WinnerNextSteps
